import { render } from "./Lista.vue?vue&type=template&id=b564562e"
import script from "./Lista.vue?vue&type=script&lang=js"
export * from "./Lista.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/AccesoGanaderos/Acopio/Lista.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b564562e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b564562e', __exports__)) {
    api.reload('b564562e', __exports__)
  }
  
  module.hot.accept("./Lista.vue?vue&type=template&id=b564562e", () => {
    api.rerender('b564562e', render)
  })

}


export default __exports__